'use client';

import Link from 'next/link';
import { ActionButton } from '../../../../components/form';
import ImageView from '../../../../components/ui/ImageView/ImageView';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import type { WChanceCollectionPrizeItem } from '../../../../types/wchance';
import { getSurveyStatus } from '../../utils';
import styles from './WChanceCollectionPrize.module.scss';

export interface WChanceCollectionPrizeProps {
  wChanceCollectionPrizes: Array<WChanceCollectionPrizeItem>;
  tabKey: string;
  onButtonClick?: (collection: WChanceCollectionPrizeItem, surveyStatusKey: string) => Promise<void>;
  isLoading?: boolean;
}

function WChanceCollectionPrize({
  wChanceCollectionPrizes,
  tabKey,
  onButtonClick,
  isLoading = false,
}: WChanceCollectionPrizeProps) {
  const handleButtonClick = async (collection: WChanceCollectionPrizeItem, surveyStatusKey: string) => {
    if (onButtonClick) {
      await onButtonClick(collection, surveyStatusKey);
    }
  };

  const isLabelTab = tabKey === 'label';
  const isPendingTab = tabKey === 'pending';
  const currentLoading = isLoading;

  return (
    <>
      {wChanceCollectionPrizes.map((collection) => {
        const surveyStatus = getSurveyStatus(collection.surveyUrl, collection.surveyId, collection.isSurveyCompleted);

        return (
          <div
            className={`${styles.componentStyle} ${collection.prizeLabelId > 0 ? utilsStyles.mtXSmall : ''}`}
            key={`collection_prize_${collection.prizeLabelId}_${collection.lotteryEventId}`}
          >
            {/* リンクを貼るのはWチャンス賞チャレンジ履歴のみ */}
            {isLabelTab ? (
              <Link className={styles.prize} href={`/account/wchance-collection/lotteries/${collection.prizeLabelId}`}>
                {cardInner(collection, tabKey, styles)}
              </Link>
            ) : (
              <div className={styles.prize}>{cardInner(collection, tabKey, styles)}</div>
            )}

            {/* ボタンは未実施でのみ表示 */}
            {isPendingTab && (
              <div className={styles.linkButton}>
                <div className={styles.buttonWrap}>
                  <div className={styles.uncompletedCount}>未実施件数：{collection.totalCount}</div>
                  <ActionButton
                    type='button'
                    size='fullWidth'
                    color='primary'
                    onClick={() => handleButtonClick(collection, surveyStatus.key)}
                    isLoading={currentLoading}
                  >
                    {surveyStatus.linkText}
                  </ActionButton>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </>
  );
}

function isMultiPrize(collection: WChanceCollectionPrizeItem) {
  return collection.orderNum > 0;
}

function winText(collection: WChanceCollectionPrizeItem) {
  if (collection.wonCount > 0 && collection.submittedCount > 0) {
    return `（当選：${collection.wonCount} / 抽選待ち：${collection.submittedCount}）`;
  }
  if (collection.wonCount > 0) {
    return `（当選：${collection.wonCount}）`;
  }
  if (collection.submittedCount > 0) {
    return `（抽選待ち：${collection.submittedCount}）`;
  }

  return '';
}

function cardInner(collection: WChanceCollectionPrizeItem, tabKey: string, currentStyles: Record<string, string>) {
  return (
    <>
      <div className={currentStyles.thumbnail}>
        <ImageView src={collection.imageUrl} alt={collection.prizeLabelName} />
      </div>
      <div className={currentStyles.detailArea}>
        {isMultiPrize(collection) && <div className={currentStyles.orderText}>第{collection.orderNum}弾</div>}
        <div className={currentStyles.title}>{collection.prizeLabelName}</div>
        {tabKey === 'label' && (
          <p className={`${currentStyles.drawCount} ${utilsStyles.mtXSmall}`}>
            Wチャンス賞チャレンジ履歴　{collection.totalCount}
            {winText(collection)}
          </p>
        )}
        <p className={utilsStyles.mtSmall}>{collection.lotteryEventName}</p>
      </div>
    </>
  );
}

export default WChanceCollectionPrize;
